<template>
  <div class="app-container">
    <list ref="list" >
      <template slot="toolbar-right">
        <!-- <el-button size="mini" type="primary" @click="print('qualityPrintbatch')" :disabled='!btntype'>销货单批量打印</el-button> -->
         <!-- <el-button size="mini" type="primary" @click="print('qualityReceipt')" :disabled='!btntype'>小票批量打印</el-button> -->
      </template>
      <template #column>
        <slot name="column" />
        <template >
          <el-table-column label="操作" align="center" width="60" fixed="right">
            <template slot-scope="{row}">
              <el-button @click="onPrint2(row)" type="text">打印2</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </list>
    <import-dialog ref="importDialog" @upload-success="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/distribution/printmanagement/billprint/list";
import importDialog from "@/components/distribution/printmanagement/billprint/importDialog";
export default {
  name: "receipt",
  mixins: [curdMixins],
  components: {
    list,
    importDialog
  },
  data() {
    return {
      api: require("@/api/fund/receipt").default,
      btntype:false
    }
  },
  methods: {
    // checkChange(e){
    //      if(e.length>0){
    //        this.btntype=true
    //      }else{
    //        this.btntype=false
    //      }
    // },
    // print(url) {
    //   let rows = this.$refs.list.getCheckedRows();
       
    //   let newpage = this.$router.resolve({ 
    //     path: '/'+url+'?sid='+ rows.map(v=>v.DocId).join(',')
    //   })
    //   window.open(newpage.href, '_blank');
    // },
    onPrint2(row) {
      var url = location.origin + "/#/customprintview/销货单/" + row.DocId;
      window.open(url, "_blank");
    },
    onImport() {
      this.$refs.importDialog.open();
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => {});
    },
  },
};
</script>